var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChildFriendly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4215",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1H31.5001V32H0.5V1Z",
    fill: "white",
    stroke: "#000000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.97339 12.9426C6.89201 13.7228 8.17113 13.7155 9.08976 12.9426",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97339 10.5447V11.1836",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07336 10.5447V11.1836",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8199 9.30858V7.84383C13.8199 7.44514 13.7169 7.05527 13.5234 6.71101",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.24841 9.30856V6.04768C1.24841 5.10882 2.01086 4.34844 2.94973 4.351C3.46235 4.35244 3.95148 4.12613 4.27441 3.72794C5.03904 2.78519 6.91785 1.10925 10.612 1.10925H10.9862C11.5009 1.10925 11.9182 1.5265 11.9182 2.04125C11.9182 2.34082 12.2193 2.54682 12.4985 2.43826C13.4523 2.06732 14.5273 2.53095 14.9121 3.47925L14.943 3.55519C15.2586 4.33325 15.0428 5.22581 14.4061 5.77319C13.4015 6.63669 11.6329 7.68607 9.05198 7.68607H4.42904C4.08529 7.68607 3.80404 7.96731 3.80404 8.31106V8.59444C3.80404 8.93964 3.52424 9.21944 3.17904 9.21944H2.49304",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2734 7.49763V8.59375C11.2734 8.93888 11.5532 9.21876 11.8984 9.21876H12.571",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2673 19.0654C19.2996 20.1901 17.9734 22.3089 17.9734 24.7377V25.5086",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0205 25.5086V24.7377C31.0205 22.3075 29.6928 20.1877 27.7234 19.0635",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4734 25.5312H20.7547C22.8257 25.5312 24.5047 23.8523 24.5047 21.7813C24.5047 23.8523 26.1836 25.5312 28.2547 25.5312H29.5359",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2734 31.3499H29.7866C30.477 31.3499 31.0366 30.7904 31.0366 30.1V27.9197",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9734 27.9197V30.1C17.9734 30.7904 18.5331 31.3499 19.2235 31.3499H21.7054",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.505 20.2648C25.116 20.2648 25.6116 19.7695 25.6116 19.1583C25.6116 18.5472 25.116 18.0517 24.505 18.0517C23.8938 18.0517 23.3984 18.5472 23.3984 19.1583C23.3984 19.7695 23.8938 20.2648 24.505 20.2648Z",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6286 19.8859L22.5378 20.6254C22.2162 20.8435 21.8037 20.7411 21.6306 20.3931C21.221 19.5696 21.221 18.7461 21.6306 17.9226C21.8037 17.5746 22.2162 17.4722 22.5378 17.6902L23.6376 18.4358",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3734 19.8867L26.4632 20.6254C26.7848 20.8435 27.1973 20.7411 27.3704 20.3931C27.78 19.5696 27.78 18.7461 27.3704 17.9226C27.1973 17.5746 26.7848 17.4722 26.4632 17.6902L25.3837 18.4221",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9734 9.42108V7.11678C17.9734 4.67222 19.9551 2.69046 22.3998 2.69046H26.6047C29.0492 2.69046 31.031 4.67222 31.031 7.11678V9.37721",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9484 7.70482H27.5383C27.8834 7.70482 28.1632 7.98463 28.1632 8.32981V8.59375C28.1632 8.93895 28.4431 9.21876 28.7882 9.21876H29.5421",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4734 9.21876H20.1259C20.4926 9.21876 20.7899 8.90512 20.7899 8.53844V8.32975C20.79 7.98456 21.0697 7.70482 21.4148 7.70482H24.7547",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4984 14.9125H29.7927C30.4831 14.9125 31.0427 14.3529 31.0427 13.6625V11.6592",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9734 11.6592V13.6625C17.9734 14.3529 18.5331 14.9125 19.2235 14.9125H21.5179",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4734 25.5312V27.0254C19.4734 29.7896 21.7273 32.0312 24.4915 32.0312H24.5113C27.2753 32.0312 29.5359 29.7896 29.5359 27.0254V25.5312",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5296 25.5312H30.2059C30.9234 25.5312 31.5296 26.1011 31.5296 26.8187V26.8066C31.5296 27.5242 30.9234 28.0937 30.2059 28.0937H29.4984",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4734 25.5312H18.7971C18.0796 25.5312 17.4734 26.1011 17.4734 26.8187V26.8066C17.4734 27.5242 18.0796 28.0937 18.7971 28.0937H19.5047",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9484 29.2074C23.8671 29.9877 25.1461 29.9803 26.0647 29.2074",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9484 26.8072V27.4461",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0483 26.8072V27.4461",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97339 29.2074C6.89201 29.9877 8.17113 29.9803 9.08976 29.2074",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97339 26.8072V27.4461",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07336 26.8072V27.4461",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8234 25.5664V23.7157",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08548 23.7639V24.5312C5.08548 25.0491 4.66572 25.4688 4.14798 25.4688H2.49841",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.24841 25.5726V23.723",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.39844 21.7625V20.7937C1.39844 19.0678 2.79757 17.6688 4.52345 17.6688H10.5234C12.2422 17.6688 13.6484 19.075 13.6484 20.7937V21.7625",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84838 21.7813H13.6609C14.1786 21.7813 14.5984 22.201 14.5984 22.7187V23.3437C14.5984 23.5163 14.4584 23.6563 14.2859 23.6563H0.785888C0.613328 23.6563 0.473389 23.5163 0.473389 23.3437V22.7187C0.473389 22.201 0.893136 21.7813 1.4109 21.7813H4.66088",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80138 17.67C5.61237 17.67 4.64844 18.6446 4.64844 19.8337V21.7812",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4014 21.6726V19.8261C10.4014 18.6369 9.43749 17.6715 8.24841 17.6715",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97339 23.6927V24.5312C9.97339 25.049 10.3931 25.4688 10.9109 25.4688H12.5719",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5992 2.54759C26.5267 1.66371 25.7864 0.969025 24.8838 0.969025H24.1387C23.2361 0.969025 22.4958 1.66377 22.4233 2.54766",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4734 9.21873V10.7616C19.4734 13.5257 21.7273 15.7812 24.4915 15.7812H24.5113C27.2753 15.7812 29.5359 13.5257 29.5359 10.7616V9.21873",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5296 9.21873H30.2059C30.9234 9.21873 31.5296 9.81297 31.5296 10.5305V10.5376C31.5296 11.255 30.9234 11.8437 30.2059 11.8437H29.4984",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4734 9.21873H18.7971C18.0796 9.21873 17.4734 9.81297 17.4734 10.5305V10.5376C17.4734 11.255 18.0796 11.8437 18.7971 11.8437H19.5047",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9484 12.9426C23.8671 13.7228 25.1461 13.7155 26.0647 12.9426",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9484 10.5447V11.1836",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0483 10.5447V11.1836",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.49841 25.4688V27.0254C2.49841 29.7896 4.75235 32.0312 7.51641 32.0312H7.53628C10.3003 32.0312 12.5609 29.7896 12.5609 27.0254V25.4688",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.49841 9.21873V10.7755C2.49841 13.5396 4.75235 15.7812 7.51641 15.7812H7.53628C10.3003 15.7812 12.5609 13.5396 12.5609 10.7755V9.21873",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5547 9.21873H13.231C13.9485 9.21873 14.5547 9.81297 14.5547 10.5305V10.5376C14.5547 11.255 13.9485 11.8437 13.231 11.8437H12.5234",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.49841 9.21873H1.82211C1.1046 9.21873 0.498413 9.81297 0.498413 10.5305V10.5376C0.498413 11.255 1.1046 11.8437 1.82211 11.8437H2.52966",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5547 25.4688H13.231C13.9485 25.4688 14.5547 26.063 14.5547 26.7805V26.7875C14.5547 27.5051 13.9485 28.0937 13.231 28.0937H12.5234",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.49841 25.4688H1.82211C1.1046 25.4688 0.498413 26.063 0.498413 26.7805V26.7875C0.498413 27.5051 1.1046 28.0937 1.82211 28.0937H2.52966",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildFriendly);
export default __webpack_public_path__ + "static/media/child_friendly.a25128525b152b34a6aa579a4cea6d8b.svg";
export { ForwardRef as ReactComponent };